import React, { useEffect, useRef } from 'react';
import './AnimatedColorBar.css';

const AnimatedColorBar = () => {
  const wrapperRef = useRef(null);
  const navyBarRef = useRef(null);
  const yellowBarRef = useRef(null);

  useEffect(() => {
    const updateTop = () => {
      const nav = document.querySelector('nav');
      const navHeight = nav ? nav.getBoundingClientRect().height : 0;
      if (wrapperRef.current) {
        wrapperRef.current.style.top = `${navHeight}px`;
      }
    };

    const handleScroll = () => {
      updateTop();
      const scrollHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      if (scrollHeight === 0) {
        if (navyBarRef.current) navyBarRef.current.style.left = '0%';
        if (yellowBarRef.current) yellowBarRef.current.style.left = '50%';
        return;
      }

      const scrollY = window.scrollY;
      const progress = Math.min(scrollY / scrollHeight, 1); // Progress 0 (top) to 1 (bottom)

      if (navyBarRef.current && yellowBarRef.current) {
        // At progress 0 (top), navy is at 0%, yellow is at 50%
        // At progress 1 (bottom), navy is at 50%, yellow is at 0%
        const navyLeft = 50 * progress;
        const yellowLeft = 50 * (1 - progress);

        navyBarRef.current.style.left = `${navyLeft}%`;
        yellowBarRef.current.style.left = `${yellowLeft}%`;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', updateTop);
    updateTop();
    handleScroll(); // Set initial state on mount
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', updateTop);
    };
  }, []);

  return (
    <div ref={wrapperRef} className="color-bar-wrapper">
      <div ref={navyBarRef} className="bar-navy"></div>
      <div ref={yellowBarRef} className="bar-yellow"></div>
    </div>
  );
};

export default AnimatedColorBar; 